module.exports = [
  {
    name: "Home",
    route: "/costa-pez/home",
    icon: "cp-home"
  },
  {
    name: "Nuevo registro",
    route: "/costa-pez/nuevo",
    icon: "cp-fish-1"
  },
  {
    name: "Mis buceos",
    route: "/costa-pez/mis-buceos",
    icon: "cp-diver-3"
  },
  {
    name: "Búsqueda",
    route: "/costa-pez/buscador",
    icon: "cp-search"
  },
  {
    name: "Mi cuenta",
    route: "/costa-pez/usuario/mi-cuenta",
    icon: "cp-user"
  },
  {
    name: "Biblioteca",
    route: "/costa-pez/biblioteca",
    icon: "cp-library"
  }
];
